import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { useNavigate, useRightPanel } from "../../../common";
import { MediumCustomIcon } from "../../layer00";
import { CriteriaIconButton } from "../../layer01";
import { ReactNode } from "react";

type ActivityHeaderSectionLayoutProps = {
  title?: string;
  subtitle?: string;
  actionButtons?: ReactNode | ReactNode[];
  children?: ReactNode;
  icon?: ReactNode;
  backButton?: ReactNode;
  overrideReturnPath?: string;
};

export const ActivityHeaderSectionLayout = (
  props: ActivityHeaderSectionLayoutProps
) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const rightPanel = useRightPanel();
  const isDark = theme.palette.mode === "dark";

  const getSettingsIconStroke = () => {
    if (rightPanel.activePanel === "settings") return theme.palette.info.main;
    return isDark ? "var(--team-app-stripe-mid)" : undefined;
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      columnGap=".5rem"
      rowGap="1.5rem"
    >
      {props.icon && (
        <Box
          display={{
            xs: "none",
            sm: "block",
          }}
        >
          {props.icon}
        </Box>
      )}
      <Box
        display="flex"
        flexDirection="row"
        flex="1 1 0"
        minWidth={0}
        columnGap=".75rem"
      >
        {props.backButton && (
          <IconButton
            onClick={() => navigate(props.overrideReturnPath ?? "..")}
            sx={{
              borderRadius: ".25rem",
              bgcolor: theme.palette.grey["500"],
            }}
          >
            <MediumCustomIcon icon="CHEVRONLEFT" />
          </IconButton>
        )}
        <Stack direction="column" flex="1 1 0" rowGap="0">
          <Stack
            direction="row"
            columnGap=".75rem"
            flex="1 1 0"
            justifyContent="space-between"
          >
            {props.title && (
              <Typography
                variant="activityTitle"
                flex="1 1 0"
                sx={{
                  fontSize: {
                    xs: "20px",
                    sm: "1.75rem",
                  },
                }}
              >
                {props.title}
              </Typography>
            )}

            {/* ACTIONS */}
            {props.actionButtons ?? null}
          </Stack>

          {props.subtitle && (
            <Typography
              variant="activitySubtitle"
              sx={{
                fontSize: {
                  xs: "14px",
                  sm: "1rem",
                },
                lineHeight: {
                  xs: "16px",
                  sm: "1.625rem",
                },
              }}
            >
              {props.subtitle}
            </Typography>
          )}
        </Stack>
      </Box>
      {/* METRICS */}
      {props.children}

      <Stack
        direction="row"
        columnGap=".5rem"
        height="2.5rem"
        flexShrink={0}
        marginLeft="auto"
      >
        <CriteriaIconButton
          aria-label="Settings"
          onClick={() => rightPanel.toggle("settings")}
          icon={
            <MediumCustomIcon
              icon="SETTINGS"
              stroke={getSettingsIconStroke()}
            />
          }
        />
      </Stack>
    </Box>
  );
};
